<app-container [paddingValues]='"18px 16px"' *ngIf="questionsAndAnswers && questionsAndAnswers.length >0 ">
    <app-title [title]='"שאלות ותשובות נפוצות"'></app-title>
    <div class="questions-and-answers-continer">
        <p-accordion  expandIcon="pi pi-fw pi-chevron-left">
          <p-accordionTab header={{question.Question}} 
                          *ngFor="let question of questionsAndAnswers">
            <div [innerHTML]="question.Answer"></div>
          </p-accordionTab>
        </p-accordion>
    </div>
    
</app-container>
